import { useEffect, useState } from 'react';
import { runInAction } from 'mobx';
import { type AnnotationsMap } from 'mobx/dist/internal';
import { safelyMakeObservable } from '../util';

type NoInfer<T> = [T][T extends any ? 0 : never];

export function useSyncProps<
  P extends object,
  AdditionalKeys extends PropertyKey = never,
>(props: P, annotations?: AnnotationsMap<P, NoInfer<AdditionalKeys>>) {
  const [syncedProps] = useState(() =>
    safelyMakeObservable(props, annotations, {
      deep: false,
    }),
  );

  // sync all props using Object.assign on every render (as not passing deps to useEffect)
  useEffect(() => {
    runInAction(() => {
      Object.assign(syncedProps, props);
    });
  });

  return syncedProps;
}
